"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Dots = require("./Dots");

var _Dots2 = _interopRequireDefault(_Dots);

var _Hourglass = require("./Hourglass");

var _Hourglass2 = _interopRequireDefault(_Hourglass);

var _Lock = require("./Lock");

var _Lock2 = _interopRequireDefault(_Lock);

var _Windmill = require("./Windmill");

var _Windmill2 = _interopRequireDefault(_Windmill);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Animation = function Animation(props) {
  switch (props.type) {
    case 'dots':
      return _react2.default.createElement(_Dots2.default, props);

    case 'hourglass':
      return _react2.default.createElement(_Hourglass2.default, props);

    case 'lock':
      return _react2.default.createElement(_Lock2.default, props);

    case 'windmill':
      return _react2.default.createElement(_Windmill2.default, props);

    default:
      return null;
  }
};

Animation.defaultProps = _propTypes3.animationDefaultProps;
Animation.propTypes = _propTypes3.animationPropTypes;
exports.default = Animation;